import { __awaiter } from "tslib";
import { InterconsultService } from "@/servicesTs/models/interconsult/interconsult";
const moduleTableInterconsultAdmission = {
    namespaced: true,
    state: {
        interconsults: [],
        filters: {
            list: null,
            request_date_start: null,
            request_date_end: null,
            priority: null,
            new_origin_service_id: null,
            service_node_id: null,
            unity_node_id: null,
            ges: null,
            diagnostic: null,
            destination_node_id: null,
            origin_node_id: null,
            patient_id: null,
            order: "ASC",
            is_spontaneous: null,
            aps_request_state: null,
            patient_name: null,
            patient_apepat: null,
            patient_apemat: null,
            page: 1,
        },
        loading: false,
    },
    getters: {
        getInterconsults(state) {
            return state.interconsults;
        },
        getFilters(state) {
            return state.filters;
        },
        getLoading(state) {
            return state.loading;
        },
    },
    mutations: {
        setInterconsult(state, interconsults) {
            state.interconsults = interconsults;
        },
        setFilter(state, filter) {
            state.filters = filter;
        },
        setFilter_list(state, list) {
            state.filters.list = list;
        },
        setFilter_request_date_start(state, request_date_start) {
            state.filters.request_date_start = request_date_start;
        },
        setfilter_request_date_end(state, request_date_end) {
            state.filters.request_date_end = request_date_end;
        },
        setFilter_priority(state, priority) {
            state.filters.priority = priority;
        },
        setFilter_new_origin_service_id(state, new_origin_service_id) {
            state.filters.new_origin_service_id = new_origin_service_id;
        },
        setFilter_service_node_id(state, service_node_id) {
            state.filters.service_node_id = service_node_id;
        },
        setFilter_unity_node_id(state, unity_node_id) {
            state.filters.unity_node_id = unity_node_id;
        },
        setFilter_ges(state, ges) {
            state.filters.ges = ges;
        },
        setFilter_diagnostic(state, diagnostic) {
            state.filters.diagnostic = diagnostic;
        },
        setFilter_destination_node_id(state, destination_node_id) {
            state.filters.destination_node_id = destination_node_id;
        },
        setFilter_origin_node_id(state, origin_node_id) {
            state.filters.origin_node_id = origin_node_id;
        },
        setFilter_patient_id(state, patient_id) {
            state.filters.patient_id = patient_id;
        },
        setFilter_is_spontaneous(state, is_spontaneous) {
            state.filters.is_spontaneous = is_spontaneous;
        },
        setFilter_aps_request(state, aps_request) {
            state.filters.aps_request_state = aps_request;
        },
        setFilter_order(state, order) {
            state.filters.order = order;
        },
        setFilter_page(state, page) {
            state.filters.page = page;
        },
        setFilter_patient_name(state, patient_name) {
            state.filters.patient_name = patient_name;
        },
        setFilter_patient_apepat(state, patient_apepat) {
            state.filters.patient_apepat = patient_apepat;
        },
        setFilter_patient_apemat(state, patient_apemat) {
            state.filters.patient_apemat = patient_apemat;
        },
        setLoading(state, loading) {
            state.loading = loading;
        },
    },
    actions: {
        getInterconsults({ commit, state }) {
            return __awaiter(this, void 0, void 0, function* () {
                commit("setLoading", true);
                const INTERCONSULT = yield InterconsultService.filterInterconsultsManagement(state.filters);
                commit("setInterconsult", INTERCONSULT);
                commit("setLoading", false);
            });
        },
        clearFilter({ commit, state }) {
            return __awaiter(this, void 0, void 0, function* () {
                commit("setLoading", true);
                commit("setFilter", {
                    list: "Todos",
                    request_date_start: null,
                    request_date_end: null,
                    priority: null,
                    new_origin_service_id: null,
                    service_node_id: null,
                    unity_node_id: null,
                    ges: null,
                    diagnostic: null,
                    destination_node_id: null,
                    origin_node_id: null,
                    patient_id: null,
                    order: "ASC",
                    is_spontaneous: null,
                    aps_request: null,
                    patient_name: null,
                    patient_apepat: null,
                    patient_apemat: null,
                    page: 1,
                });
                commit("setInterconsult", {});
                commit("setLoading", false);
            });
        },
    },
};
export default moduleTableInterconsultAdmission;
